import React, { useContext, useState } from "react";
import { ButtonProps, EditButton, Aside } from "sprint-common-web";

import { TvSeriesPageContext } from "../../context/TvSeriesPageContext";
import { EditTvSeriesInfoForm, UpdatedTvSeriesData } from "../edit-form/EditTvSeriesInfoForm";

export type EditTvSeriesButtonProps = Pick<ButtonProps, "styles" | "disabled"> & {
    isLabeled?: boolean;
    onClick?(): void;
};

export const EditTvSeriesButton: React.FunctionComponent<EditTvSeriesButtonProps> = (
    props: EditTvSeriesButtonProps
) => {
    const [isAsideOpen, setIsAsideOpen] = useState<boolean>(false);
    const tvSeriesPageContext = useContext(TvSeriesPageContext);

    const handleClick = () => {
        setIsAsideOpen(true);
        if (props.onClick) {
            props.onClick();
        }
    };

    const handleEditTvSeriesFormSubmit = (updatedTvSeriesData: UpdatedTvSeriesData) => {
        tvSeriesPageContext.editTvSeries(updatedTvSeriesData.title);
        setIsAsideOpen(false);
    };

    const closeEditTvSeriesSidebar = () => {
        setIsAsideOpen(false);
    };

    return (
        <>
            <EditButton onClick={handleClick} isLabeled={props.isLabeled} testId="edit-tvseries" />
            <Aside isOpen={isAsideOpen} type="form" headerText="Edit Tv Series" onDismiss={closeEditTvSeriesSidebar}>
                <EditTvSeriesInfoForm onCancel={closeEditTvSeriesSidebar} onSubmit={handleEditTvSeriesFormSubmit} />
            </Aside>
        </>
    );
};
